<script lang="ts">
  import NauiInput from "./../lib/naui/atoms/NauiInput.svelte";
  import NauiButton from "../lib/naui/atoms/NauiButton.svelte";
  import NauiCheckbox from "../lib/naui/atoms/NauiCheckbox.svelte";
  import AuditoriaItem from "./components/AuditoriaItem.svelte";
  import AuditoriaItemXLS from "./components/AuditoriaItemXLS.svelte";
  import { onMount } from "svelte";
  import NauiDatePicker from "../lib/naui/atoms/NauiDatePicker.svelte";
  import NauiSelect from "../lib/naui/atoms/NauiSelect.svelte";
  import Dialog, { Actions, Content, Title } from "@smui/dialog";
  import { TableExport } from "tableexport";
  import {validarHorario } from "../lib/utils/requests";

  export let data = [];
  export let vendorAct;
  export let horario;
  export let max_liquidar;
  export let subruta;
  export let direcciones;

 
  const isPaqueteCompleto = subruta === "paqueteCompleto";
  const isMaquila= subruta === "maquila";
  let MAXIMO_LIQUIDAR;
  let dialogOpen = false;
  let dialogOpenOK = false;
  let deshabilitarBtnAuditar = false;
  let refs = [];
  let vendor_dir = [];
  let referencia_sel = " ";
  let direccion_sel;
  let PO = "";
  let TipoAuditoria = "Primeras";
  let TipoEmpaque = "Individual";
  const expRegular = /^Q[1-4]-20[1-9][0-9]$/;
  let Q = "";
  let Orden = "";
  let Critica;
  let Auditada;
  let Liquidar;
  let Cantidad = 1;
  let Fecha = formatoFecha(fechaDeManana(),"yyyy-mm-dd"); //.toLocaleDateString();
  let Hora = "08:00";
  let Medida;
  let Empaque;
  let Confeccion;
  let swSegundasDesactivar = false;
  let AuditoriaItems = [];
  let CantTotal = 0;
  let cant = 0;
  let resp = [];
  let mensaje = "";
  let referencias_po = [];
  let tipos_empaque = [
    {
      label: "Individual    ",
      value: "Individual",
    },
    {
      label: "Prepack",
      value: "Prepack",
    },
  ];
  let tipos_auditoria = [
    {
      label: "Primeras",
      value: "Primeras",
    },
    {
      label: "Segundas",
      value: "Segundas",
    },
  ];

  onMount(async () => {

    if(!(await validarRangoHora())){
      return false
    }

    refs = data.map((y) => {
      return {
        label: y.codigo + " - " + y.description,
        value: y.codigo + " - " + y.description,
      };
    });
    vendor_dir = direcciones.map((y) => {
      return {
        label: y.descripcion,
        value: y.descripcion,
      };
    });

    
    MAXIMO_LIQUIDAR = max_liquidar.valor;

  });

  // coloca el primer valor por defecto cuando solo hay una dirección de proveedor
  $: if (vendor_dir.length === 1) {
    direccion_sel = vendor_dir[0].value;
  }

  async function validarRangoHora(){
        const resultado = await validarHorario(horario, 'solicitar');
        if (!resultado.valido) {
            mensaje = resultado.mensaje;
            dialogOpen = true;
            return false;
        }
        return true;
    }

  async function guardar() {

     if(!(await validarRangoHora())){
      return false
    }

    deshabilitarBtnAuditar = true;
    if (CantTotal != 0) {
      const payload = AuditoriaItems;
      const response = await fetch("/auditoria/guardar_solicitud", {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      resp = await response.json();
      mensaje = resp["mensaje"];
      dialogOpen = true;
      if (response.ok) {
        deshabilitarBtnAuditar = false;
      }
    } else {
      mensaje = "Debe Ingresar Items a Auditar";
      deshabilitarBtnAuditar = false;
      dialogOpenOK = true;
    }
  }

  function agregar() {
    let swOrdenReferencia = validarOrdenCorteYReferencia();
    let id_direccion = direcciones.find((x) => x.descripcion === direccion_sel).valor;

    if (isPaqueteCompleto) {
      if (PO === "") {
        mensaje = "El campo [P.O] es requerido";
        dialogOpenOK = true;
        return false;
      }
    }

    if (direccion_sel === "") {
      mensaje = "El campo [Dirección] es requerido";
      dialogOpenOK = true;
      return false;
    }

    if(id_direccion === null){
      mensaje = "La dirección seleccionada no es válida";
      dialogOpenOK = true;
      return false;
    }

    if (referencia_sel === " ") {
      mensaje = "El campo [Referencia] es requerido";
      dialogOpenOK = true;
      return false;
    }

    if (TipoAuditoria === "Primeras") {
      if (Q === "") {
        mensaje = "El campo [Q] es requerido";
        dialogOpenOK = true;
        return false;
      }

      if (!expRegular.test(Q)) {
        mensaje = `${expRegular.test(Q)}  - El campo [Q] no cumple con el formato requerido. \nEjemplo: "${calcularQ()}"`;
        dialogOpenOK = true;
        return false;
      }

      if (!Liquidar && Cantidad < MAXIMO_LIQUIDAR) {
        mensaje = "No puede solicitar unidades menores a " + MAXIMO_LIQUIDAR;
        dialogOpenOK = true;
        return false;
      }
    }

    if (swOrdenReferencia) {
      const item = {
        id: cant,
        Direccion_descripcion: direccion_sel,
        Direccion_id: id_direccion,
        referencia_sel: referencia_sel,
        TipoAuditoria: isPaqueteCompleto ? null: TipoAuditoria,
        TipoEmpaque: TipoAuditoria === "Segundas" ? "" : TipoEmpaque,
        Q: TipoAuditoria === "Segundas" ? "" : Q,
        Orden: isPaqueteCompleto? null: Orden,
        Critica: isPaqueteCompleto ? null: (TipoAuditoria === "Segundas" ? false : Critica),
        Auditada: isPaqueteCompleto? null: (TipoAuditoria === "Segundas" ? false : Auditada),
        Cantidad: Cantidad,
        Fecha: Fecha,
        Hora: Hora,
        Medida: TipoAuditoria === "Segundas" ? false : Medida,
        Empaque: TipoAuditoria === "Segundas" ? false : Empaque,
        Confeccion: TipoAuditoria === "Segundas" ? false : Confeccion,
        checked: false,
        Liquidar: isPaqueteCompleto? null: (TipoAuditoria === "Segundas" ? false : Liquidar),
        PO: isPaqueteCompleto ? PO:null,
        ProcesoAuditado: isPaqueteCompleto ? "Paquete Completo":"Maquila"
      };
      cant++;
      AuditoriaItems.push(item);
      AuditoriaItems = AuditoriaItems;
      CalcularTotal();
    } else {
      return false;
    }
  }

  function quitar() {
    AuditoriaItems = AuditoriaItems.filter((x) => x.checked == false);
    CalcularTotal();
  }
  function cancelar() {
    document.location = `/auditoria/home/${subruta}`;
  }

  function CalcularTotal() {
    let Total = 0;
    if (AuditoriaItems.length > 0) {
      AuditoriaItems.forEach((x) => {
        Total += x.Cantidad;
      });
    }
    CantTotal = Total;
    return Total;
  }

  const calcularQ = () => {
    const f = new Date();
    const mes = f.getMonth();
    var ano = f.getFullYear();
    if (mes >= 10) ano++;
    const qs = [4, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
    return `Q${qs[mes]}-${ano}`;
  };

  function fechaDeManana() {
    let hoy = new Date();
    let DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
    let manana = new Date(hoy.getTime() + DIA_EN_MILISEGUNDOS);
    return manana;
  }

  function formatoFecha(fecha, formato) {
    const map = {
      dd: fecha.getDate() >= 10 ? fecha.getDate() : "0" + fecha.getDate(),
      mm:
        fecha.getMonth() * 1 + 1 >= 10
          ? fecha.getMonth() * 1 + 1
          : "0" + (fecha.getMonth() * 1 + 1),
      yyyy: fecha.getFullYear(),
    };
   

    return formato.replace(/yyyy|mm|dd/gi, (matched) => map[matched]);
  }


  function validarOrdenCorteYReferencia() {
    if (isMaquila) {
      if (Orden == "" || referencia_sel == " ") {
        mensaje = "Los campos de orden de corte y referencia son requeridos";
        dialogOpenOK = true;
        return false;
      }
    }

    return true;
  }

  function opcionSegundasDesactivar() {
    if (TipoAuditoria === "Segundas") {
      swSegundasDesactivar = true;
    } else {
      swSegundasDesactivar = false;
    }
  }

  async function fetchReferenciasPorPO() {
    referencia_sel = " ";
    if (PO) {
      try {
        const response = await fetch(
          `/auditoria/buscar_referencias_por_po/${PO}`,
          {
            method: "GET",
            credentials: "include",
          },
        );

        if (response.ok) {
          const data = await response.json();
          referencias_po = data.data;

          refs = referencias_po.map((y) => {
            return {
              label: y.codigo + " - " + y.descripcion,
              value: y.codigo + " - " + y.descripcion,
            };
          });
        } else if (response.status === 404) {
          const errorData = await response.json();
          mensaje = errorData.mensaje || "La P.O ingresada no existe.";
          referencias_po = [];
          dialogOpenOK = true;
          refs = [];
        } else {
          mensaje = "Ocurrió un error al obtener las referencias.";
          referencias_po = [];
          dialogOpenOK = true;

          refs = [];
        }
      } catch (error) {
        mensaje = `Error de red: ${error.message}`;
        referencias_po = [];
        refs = [];
      }
    }
    
  }

  function volver() {
    window.location.href =`/auditoria/home/${subruta}`;
  }

  function excel() {
    let tabla = document.querySelector("#tabla");
    let tableExport = new TableExport(tabla, {
      exportButtons: false, // No queremos botones
      filename:
      isMaquila
          ? "Auditoria Maquila"
          : "Auditoria Paquete Completo",
      sheetname: "Pedir Auditoria",
    });
    let datos = tableExport.getExportData();
    let preferenciasDocumento = datos.tabla.xlsx;
    tableExport.export2file(
      preferenciasDocumento.data,
      preferenciasDocumento.mimeType,
      preferenciasDocumento.filename,
      preferenciasDocumento.fileExtension,
      preferenciasDocumento.merges,
      preferenciasDocumento.RTL,
      preferenciasDocumento.sheetname,
    );
  }

</script>

<section>


  <table class="naui-table w-70">
    <thead>
      <tr>
        <th> Vendor </th>
        <th> Código Sap </th>
        <th> Total unidades </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          {vendorAct.name}
        </td>
        <td>
          {vendorAct.codigo_sap}
        </td>
        <td>
          {CantTotal}
        </td>
        <td>
          <div>
            <NauiButton
              caption="Pedir Auditoria"
              mode="outline"
              color="accent"
              disabled={deshabilitarBtnAuditar}
              on:click={deshabilitarBtnAuditar === false ? guardar : () => {}}
            />
          </div>
        </td>
        <td>
          <NauiButton
            caption="Descargar Excel"
            mode="outline"
            color="accent"
            on:click={excel}
          />
        </td>
        <td>
          <div>
            <NauiButton
              caption="Cancelar"
              mode="outline"
              color="accent"
              on:click={cancelar}
            />
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <table class="naui-table w-100" id="tabla" style="display:none ;">
    <thead>
      <tr>
        <th> Dirección </th>
        {#if isPaqueteCompleto}
          <th> P.O </th>
        {/if}
        <th> Referencia </th>
        {#if isMaquila}
          <th> Tipo de Auditoría </th>
          <th width="1%"> Liquidar Referencia </th>
        {/if}
        <th> Tipo de Empaque </th>
        <th width="100px"> Q </th>
        {#if isMaquila}
          <th width="100px"> Orden de Corte </th>
          <th width="1%"> Crítica </th>
          <th width="1%"> Auditada </th>
        {/if}
        <th width="1%"> Cantidad </th>

        <th> Fecha </th>
        <th width="100px"> Hora </th>
        <th width="1%"> Medida </th>
        <th width="1%"> Empaque </th>
        <th width="1%"> Confección </th>
      </tr>
    </thead>
    <tbody>
      {#each AuditoriaItems as itemE (itemE.id)}
        {#if isPaqueteCompleto}
          <AuditoriaItemXLS data={itemE} subruta={subruta}  />
        {:else if isMaquila}
          <AuditoriaItemXLS data={itemE} subruta={subruta}  />
        {/if}
      {/each}
    </tbody>
  </table>

  <table class="table naui-table w-100">
    <thead>
      <tr>
        <th style="justify-items: center;">
          <NauiButton
            icon="disabled_by_default"
            mode="outline"
            color="accent"
            iconStyle="outlined"
            on:click={quitar}
          />
        </th>
        <th> Dirección</th>
        {#if isPaqueteCompleto}
          <th > P.O </th>
        {/if}
        <th> Referencia</th>
        {#if isMaquila}
          <th> Tipo de Auditoría </th>
          <th > Orden de Corte </th>
          <th > Liquidar Referencia </th>
          <th> Crítica </th>
          <th> Auditada </th>
        {/if}
        <th> Tipo de Empaque </th>
        <th> Q </th>
        <th> Cantidad </th>
        <th> Fecha </th>
        <th> Hora </th>
        <th> Medida </th>
        <th> Empaque </th>
        <th> Confección </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="justify-items: center;">
          <NauiButton
            icon="add_circle_outline"
            mode="outline"
            color="accent"
            iconStyle="outlined"
            on:click={agregar}
          />
        </td>
        <td width="100px">
          <div style="position:relative; width: 100px">
           
              <NauiSelect
                bind:value={direccion_sel}
                options={vendor_dir ? vendor_dir : []}
                label=""
              />
          </div>
        </td>
        {#if isPaqueteCompleto}
          <td width="100px">
            <div style="position:relative; width:100%; max-width:100px;">
                <input type="text" style="margin-top:5%;"
                bind:value={PO}
                placeholder="P.O"
                label=""
                on:blur={fetchReferenciasPorPO()}
                on:click={() => {fetchReferenciasPorPO(); }}
                on:keypress={(e) => { if (e.key === 'Enter') fetchReferenciasPorPO(); }}
              />
          </td>
        {/if}
       
        <td width="100px">
          <div style="position:relative; width: 100px">
            {#if isMaquila}
              <NauiSelect bind:value={referencia_sel} options={refs} label=""/>
            {:else if isPaqueteCompleto}
              <NauiSelect
                bind:value={referencia_sel}
                options={PO ? refs : []}
                label=""
                disabled={isPaqueteCompleto && (!PO || referencias_po.length === 0)}
              />
            {/if}
          </div>
            
        </td>

        {#if isMaquila}
          <td>
            <NauiSelect
              bind:value={TipoAuditoria}
              options={tipos_auditoria}
              label=""
              on:change={opcionSegundasDesactivar}
            />
          </td>
          <td width="150px">
            <NauiInput bind:value={Orden} type="text" label="" />
          </td>
          <td>
            <NauiCheckbox
              bind:value={Liquidar}
              disabled={swSegundasDesactivar}
            />
          </td>
          <td>
            <NauiCheckbox
              bind:value={Critica}
              disabled={swSegundasDesactivar}
            />
          </td>
          <td>
            <NauiCheckbox
              bind:value={Auditada}
              disabled={swSegundasDesactivar}
            />
          </td>
        {/if}
        <td  class="pl-0">
          <NauiSelect
            bind:value={TipoEmpaque}
            options={tipos_empaque}
            label=""
            disabled={swSegundasDesactivar}
          />
        </td>
        <td >
          <NauiInput
            bind:value={Q}
            placeholder={calcularQ()}
            type="text"
            label=""
            isDisabled={swSegundasDesactivar}
          />
        </td>
        <td>
          <NauiInput bind:value={Cantidad} min={1} type="number" label="" />
        </td>

        <td>
          <NauiDatePicker bind:value={Fecha} label="" />
        </td>
        <td padding-right="-10px">
          <input
            style="margin-top:7%;"
            bind:value={Hora}
            type="time"
            label=""
          />
        </td>
        <td>
          <NauiCheckbox bind:value={Medida} disabled={swSegundasDesactivar} />
        </td>
        <td>
          <NauiCheckbox bind:value={Empaque} disabled={swSegundasDesactivar} />
        </td>
        <td>
          <NauiCheckbox
            bind:value={Confeccion}
            disabled={swSegundasDesactivar}
          />
        </td>
      </tr>
      <tr />
      {#each AuditoriaItems as itemE (itemE.id)}
        {#if isMaquila}
          <AuditoriaItem {refs}
          data={itemE}
          subruta="maquila"
          />
        {:else if isPaqueteCompleto}
          <AuditoriaItem
            data={itemE}
            {refs}
            subruta="paqueteCompleto"
          />
        {/if}
      {/each}
    </tbody>
  </table>


   
  <Dialog bind:open={dialogOpen} scrimClickAction="" escapeKeyAction="">
    <Title>
      <h3 class="text-c">Pedir auditoría</h3>
    </Title>
    <Content>
      <div class="max-w-400px text-c mx-auto px-15">
        <p class="large">
          {mensaje}
        </p>
      </div>
    </Content>
    <Actions>
      <div class="box-r sx-ii px-1 py-ii">
        <NauiButton caption="VOLVER" color="accent" on:click={volver} />
      </div>
    </Actions>
  </Dialog>

  <Dialog bind:open={dialogOpenOK}>
    <Title>
      <h3 class="text-c">Pedir auditoría</h3>
    </Title>
    <Content>
      <div class="max-w-400px text-c mx-auto px-15">
        <p class="large">
          {mensaje}
        </p>
      </div>
    </Content>
    <Actions>
      <div class="box-r sx-ii px-1 py-ii">
        <NauiButton
          caption="Aceptar"
          color="accent"
          on:click={() => {
            dialogOpenOK = false;
          }}
        />
      </div>
    </Actions>
  </Dialog>
</section>

<style>
  /* Asegura que las celdas estén alineadas verticalmente al centro */
  td {
    text-align: center;
    vertical-align: middle; /* Alinea verticalmente al centro */
  }

  /* Asegura que las filas tengan una altura consistente */
  tr {
    display: table-row;
    height: auto; /* Ajusta automáticamente la altura de las filas */
  }

  /* Asegura que las celdas tengan un diseño consistente */
  td, th {
    padding: 8px; /* Espaciado interno */
    box-sizing: border-box; /* Incluye el padding en el tamaño total */
  }

  /* Estilo para los encabezados */
  th {
    background-color: #f4f4f4;
    font-weight: bold;
  }

  /* Estilo para la tabla */
  .table {
    margin-top: 1%;
    margin-bottom: 1%;
    width: 100%;
    border-collapse: collapse;
  }

  /* Opcional: Ajusta el diseño para pantallas pequeñas */
  @media screen and (max-width: 768px) {
    .table {
      display: block;
      overflow-x: auto;
      white-space: nowrap;
    }

    th, td {
      display: block;
      width: 100%;
    }

    thead {
      display: none; /* Oculta el encabezado en pantallas pequeñas */
    }

    tr {
      display: block;
      margin-bottom: 1rem; /* Espaciado entre filas */
    }

    td {
      text-align: left;
      padding: 0.5rem;
      position: relative;
    }

    td::before {
      content: attr(data-label); /* Muestra el nombre de la columna */
      font-weight: bold;
      display: inline-block;
      margin-right: 0.5rem;
    }
  }

  /* Estilo para los botones */
  .btn-search {
    width: 2rem;
    height: 2.1rem;
    background-color: transparent;
    position: absolute;
    right: 1px;
    top: 24%;
    border: 1px solid var(--accent);
    border-radius: 10%;
  }

  /* Estilo para los spans */
  span {
    display: flex;
    font-size: 1.5rem;
    color: #31b0a5;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 0;
  }

  /* Estilo para los inputs y selects */
  input, select {
    width: 100%;
    box-sizing: border-box;
  }

  /* Asegura que las celdas estén alineadas verticalmente al centro */
  td {
    text-align: center;
    vertical-align: middle; /* Alinea verticalmente al centro */
  }

  /* Asegura que las filas tengan una altura consistente */
  tr {
    display: table-row;
    height: auto; /* Ajusta automáticamente la altura de las filas */
  }

  /* Asegura que las celdas tengan un diseño consistente */
  td, th {
    padding: 8px; /* Espaciado interno */
    box-sizing: border-box; /* Incluye el padding en el tamaño total */
  }

  /* Opcional: Ajusta el diseño para pantallas pequeñas */
  @media screen and (max-width: 768px) {
    td {
      display: block;
      width: 100%;
      text-align: left;
    }

    td::before {
      content: attr(data-label);
      font-weight: bold;
      display: inline-block;
      margin-right: 0.5rem;
    }
  }

  @media screen and (max-width: 768px) {
    .table {
      display: block;
      overflow-x: auto;
      white-space: nowrap;
    }

    th, td {
      display: block;
      width: 100%;
    }

    thead {
      display: none;
    }

    td {
      text-align: left;
      padding: 0.5rem;
      position: relative;
    }

    td::before {
      content: attr(data-label);
      font-weight: bold;
      display: inline-block;
      margin-right: 0.5rem;
    }
  }

  
</style>
